
  import ModalDialog from "@/components/ModalDialog.vue";

  import Employee from "@/model/Employee";
  import {computed, defineComponent, reactive, ref, toRefs} from "vue";
  import OrderOperatorService, {OrderOperatorV3Dto} from "@/service/OrderOperatorService";
  import {integer, maxValue, minValue, required} from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";

  export default defineComponent({
    name: "TimeclockOperatorNumberAssignmentDialog",
    components: {
      ModalDialog
    },
    setup () {
      const initialState = {
        dialog: false,
        employee: null as unknown as Employee,
        orderUuid: null as unknown as string,
        operatorNumber: null as unknown as number,
        result: (resolved: OrderOperatorV3Dto | PromiseLike<OrderOperatorV3Dto>) => {
        }
      };

      const state = reactive({ ...initialState });
      const $externalResults = ref({});

      const resetState = () => {
        Object.assign(state, initialState);
        v$.value.$reset();
      };

      const rules = computed(() => ({
        operatorNumber: {
          required,
          integer,
          minValue: minValue(1010),
          maxValue: maxValue(2200)
        }
      }));

      const v$ = useVuelidate(rules, state, { $externalResults });

      const close = () => {
        state.dialog = false;

        setTimeout(() => {
          state.result(Promise.reject("No operator number assignd"));
        }, 300);
      };

      const open = (orderUuid: string, employee: Employee) => {
        resetState();

        state.dialog = true;
        state.orderUuid = orderUuid;
        state.employee = employee;

        return new Promise<OrderOperatorV3Dto>((resolve) => {
          state.result = resolve;
        });
      };

      const save = async () => {
        v$.value.$clearExternalResults();
        let valid = await v$.value.$validate();

        if (valid) {
          OrderOperatorService.createOrderOperatorV3(state.orderUuid, {
            employeeId: state.employee.uuid,
            operatorNumber: Number(state.operatorNumber)
          })
            .then(response => {
              state.dialog = false;
              state.result(response.data);
            })
            .catch(error => {
              $externalResults.value = {
                operatorNumber: error.response.data.title
              };
            });
        }
      };

      const name = computed(() => {
        return state.employee ? state.employee.firstName + " " + state.employee.lastName : null;
      });

      const errorMessage = computed(() => {
        return v$.value.$error ? v$.value.$errors[0].$message : null;
      });

      return {
        ...toRefs(state),
        close,
        open,
        save,
        errorMessage,
        name
      };
    }
  });
